import FieldValidator from '../field-validator';

export default class RequiredValidator extends FieldValidator {
	
	validateField(field: FormField): boolean {
		return field.value !== '';
	}
}